import { render } from "./DestinationCard.vue?vue&type=template&id=3f0c5eb0"
import script from "./DestinationCard.vue?vue&type=script&lang=js"
export * from "./DestinationCard.vue?vue&type=script&lang=js"
script.render = render

export default script